<template>
  <div
    class="fixed z-50 w-full sm:w-auto sm:right-4 sm:top-4 left-0 top-0 flex flex-col gap-2 items-end p-4 pointer-events-none"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="pointer-events-auto shadow-lg"
      :class="toastTypeClass(toast.type)"
    >
      <Icon v-if="toast.type === 'success'" name="heroicons:check-circle" />
      <Icon
        v-else-if="toast.type === 'error'"
        name="heroicons:exclamation-triangle"
      />
      <Icon
        v-else-if="toast.type === 'info'"
        name="heroicons:information-circle"
      />
      <span>{{ toast.message }}</span>
      <button class="btn btn-ghost btn-xs" @click="removeToast(toast.id)">
        <Icon name="heroicons:x-mark" />
      </button>
    </div>
  </div>
</template>

<script setup>
const { toasts, removeToast } = useToast();

function toastTypeClass(type) {
  switch (type) {
    case "success":
      return "alert alert-success";
    case "error":
      return "alert alert-error";
    case "info":
      return "alert alert-info";
    default:
      return "alert";
  }
}
</script>

<style scoped>
.alert {
  min-width: 250px;
  max-width: 400px;
  margin-bottom: 0.5rem;
  transition: all 0.3s;
}
@media (max-width: 640px) {
  .alert {
    width: 100%;
    max-width: none;
    min-width: 0;
    margin-right: 0;
  }
}
</style>
